/**
 * @file
 */

import PwTeamsOverview from "./components/Views/PwTeamsOverview";
import HkmrunTeamsOverview from "./components/Views/HkmrunTeamsOverview";
import DkmTeamsOverview from "./components/Views/DkmTeamsOverview";
import HkmrunTeamActionsOverview from "./components/Views/HkmrunTeamActionsOverview";
import DkmTeamActionsOverview from "./components/Views/DkmTeamActionsOverview";
import DecolopTeamsOverview from "./components/Views/DecolopTeamsOverview";
import DecolopTeamActionsOverview from "./components/Views/DecolopTeamActionsOverview";
import StrokesTeamsOverview from '@/components/Views/StrokesTeamsOverview.vue';
import StrokesTeamActionsOverview
  from '@/components/Views/StrokesTeamActionsOverview.vue';
import PwPosOverview from "./components/Views/PwPosOverview";
export default [
  {
    el: "pw-teams-overview",
    components: {
      PwTeamsOverview
    }
  },
  {
    el: "hkmrun-teams-overview",
    components: {
      HkmrunTeamsOverview
    }
  },
  {
    el: "dkm-teams-overview",
    components: {
      DkmTeamsOverview
    }
  },
  {
    el: "hkmrun-team-actions-overview",
    components: {
      HkmrunTeamActionsOverview
    }
  },
  {
    el: "dkm-team-actions-overview",
    components: {
      DkmTeamActionsOverview
    }
  },
  {
    el: "decolop-teams-overview",
    components: {
      DecolopTeamsOverview
    }
  },
  {
    el: "decolop-team-actions-overview",
    components: {
      DecolopTeamActionsOverview
    }
  },
  {
    el: "strokes-teams-overview",
    components: {
      StrokesTeamsOverview
    }
  },
  {
    el: "strokes-team-actions-overview",
    components: {
      StrokesTeamActionsOverview
    }
  },
  {
    el: "pw-pos-overview",
    components: {
      PwPosOverview
    }
  }
];

